/*
 * Copyright (C) 2017 - present Instructure, Inc.
 *
 * This file is part of Canvas.
 *
 * Canvas is free software: you can redistribute it and/or modify it under
 * the terms of the GNU Affero General Public License as published by the Free
 * Software Foundation, version 3 of the License.
 *
 * Canvas is distributed in the hope that they will be useful, but WITHOUT ANY
 * WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS FOR
 * A PARTICULAR PURPOSE. See the GNU Affero General Public License for more
 * details.
 *
 * You should have received a copy of the GNU Affero General Public License along
 * with this program. If not, see <http://www.gnu.org/licenses/>.
 */
import { flipAll } from './flip-message';
import ar from '../../locales/ar.json';
import bg from '../../locales/bg.json';
import cs from '../../locales/cs.json';
import da from '../../locales/da.json';
import de from '../../locales/de.json';
import el from '../../locales/el.json';
import enAU from '../../locales/en_AU.json';
import enGB from '../../locales/en_GB.json';
import en from '../../locales/en.json';
import es from '../../locales/es.json';
import faIR from '../../locales/fa_IR.json';
import frCA from '../../locales/fr_CA.json';
import fr from '../../locales/fr.json';
import he from '../../locales/he.json';
import ht from '../../locales/ht.json';
import hu from '../../locales/hu.json';
import hy from '../../locales/hy.json';
import it from '../../locales/it.json';
import ja from '../../locales/ja.json';
import ko from '../../locales/ko.json';
import mi from '../../locales/mi.json';
import nl from '../../locales/nl.json';
import nn from '../../locales/nn.json';
import nb from '../../locales/no.json';
import pl from '../../locales/pl.json';
import ptBR from '../../locales/pt_BR.json';
import pt from '../../locales/pt.json';
import ro from '../../locales/ro.json';
import ru from '../../locales/ru.json';
import sq from '../../locales/sq.json';
import sr from '../../locales/sr.json';
import sv from '../../locales/sv.json';
import tr from '../../locales/tr.json';
import ukUA from '../../locales/uk_UA.json';
import vi from '../../locales/vi.json';
import zhHans from '../../locales/zh.json';
import zhHant from '../../locales/zh_HK.json';
export default {
  enflip: flipAll(en),
  ar,
  bg,
  cs,
  da,
  de,
  el,
  'en-au': enAU,
  'en-gb': enGB,
  en,
  es,
  'fa-ir': faIR,
  'fr-ca': frCA,
  fr,
  he,
  ht,
  hu,
  hy,
  it,
  ja,
  ko,
  mi,
  nl,
  nn,
  nb,
  pl,
  'pt-br': ptBR,
  pt,
  ro,
  ru,
  sq,
  sr,
  sv,
  tr,
  'uk-ua': ukUA,
  vi,
  'zh-cn': zhHans,
  'zh-tw': zhHant
};